<template>
  <div class="card mol-center-card-width membership-card">
    <div class="mol-red-ribbon"><span>member</span></div>

    <!--  plan name and establishment date -->
    <div class="card-header">
      <h4><img :src="membership.image" />{{membership.name}}</h4>
      <div class="established-text">Est. {{membership.created}}</div>
    </div>

    <div class="card-body">

      <!--   Show Family Membership widget if its appropriate   -->
      <div v-if="isFamilyMembership" class="membership-info-panel">
        <div v-if="isMembershipOwner" class="membership-info-panel-title">Manage Members</div>
        <div v-else class="membership-info-panel-title">Members</div>
        <FamilyMembership :membership="membership" @membership-updated="$emit('membership-updated')"></FamilyMembership>
      </div>

      <!--   Show Legacy Membership info if its appropriate   -->
      <div v-if="isLegacyMembership" class="membership-info-panel">
        Thank you for being among the first to be part of myOscarList.<br>Please enjoy your complimentary legacy membership.
      </div>

      <!--   Show Subscription info if its appropriate   -->
      <div v-else class="membership-info-panel">
        <div class="membership-info-panel-title">Subscription</div>

        <!--  If I'm the owner of this subscription: show subscription-management info  -->
        <div v-if="isMembershipOwner">
          <div v-if="membership.trial_end" class="subscription-note">trial until {{membership.trial_end}}</div>
          <div v-if="membership.cancel_at" class="subscription-note">cancels {{membership.cancel_at}}</div>
<!--          <div v-if="membership.stripe.renews_on" class="subscription-note">renews {{membership.stripe.renews_on}}</div>-->
          <div class="mol-subtle-link mol-external-link manage-subscription-link" @click="openCustomerPortal"><i class="fa fa-credit-card-alt"></i> Manage Subscription</div>
        </div>

        <!--  I'm NOT the owner of this subscription: show info about the owner   -->
        <div v-else>
          This subscription is managed by<br><ProfilePicture :user="membershipOwner" :size="20"></ProfilePicture> <ProfileName :user="membershipOwner" :hide_viewed_count="true"></ProfileName>
        </div>

      </div>

    </div>

  </div>
</template>


<script>
import {userStore} from "@/userStore";
import ProfilePicture from "@/components/profile/ProfilePicture.vue";
import ProfileName from "@/components/profile/ProfileName.vue";
import axios from "axios";
import analytics from "@/analytics";
import FamilyMembership from "@/components/membership/FamilyMembershipWidget.vue";

export default {
  name: "MembershipCard",
  components: {FamilyMembership, ProfileName, ProfilePicture},
  props: ['membership'],
  data() {
    return {
    }
  },
  computed: {
    userStore() {
      return userStore;
    },
    isMembershipOwner() {
      return this.membership?.owner === userStore.getUserId();
    },
    membershipOwner() {
      if ( this.isMembershipOwner ) {
        return this.userStore.getUserId();
      }
      return this.membership?.members?.find(m => m._id === this.membership?.owner);
    },
    isFamilyMembership() {
      return this.membership?.lookup_key === 'family-membership';
    },
    isLegacyMembership() {
      return this.membership?.lookup_key === 'legacy-membership';
    }
  },
  created() {
    //console.log('membership', this.membership);
  },
  methods: {
    async openCustomerPortal() {
      axios.post('/api/membership/stripe/create-customer-portal-session', {
        return_url: this.$route.path
      })
          .then(response => {
            window.location.href = response.data;
          })
          .catch(err => {
            analytics.notifyBugsnagOfError(
                `openCustomerPortal() error`,
                {error: err}
            );
            console.log('err', err)
          });
    },
  }

}
</script>


<style scoped>

.membership-card {
  .card-header {
    background-color: inherit;
    border-style: none;

    img {
      height: 1.5em;
      margin-right: 0.2em;
    }

  }

  position: relative;
  text-align: center;

  color: var(--mol-color-win-icon);
  background-color: var(--mol-color-gold-background);
  overflow: hidden;
  margin-bottom: 40px;
  padding: 2em;

  border: solid;
  border-width: 3px;
  border-color: var(--mol-color-gold);
  border-radius: 0.375rem;

  .feature-section-title {
    color: var(--mol-color-win-icon);
    text-align: center;
    margin-bottom: 1em;
  }
}

.established-text {
  font-style: italic;
  font-size: smaller;
}



.membership-info-panel {

  padding: 20px;

  margin-right: auto;
  margin-left: auto;
  margin-top: 30px;
  /*margin-bottom: 20px;*/


  width: 100%;
  min-width: 200px;

  font-size: 1rem;

  border-style: solid;
  border-width: 0.1px;
  border-radius: 6px;

  .subscription-note {
    font-style: italic;
    font-size: smaller;
  }


  .membership-info-panel-title {

    font-size: larger;
    margin-bottom: 0.75em;
  }

  .manage-subscription-link {
    margin-top: 1.5em;
  }
}



</style>